import React from 'react';

import { useLoadParentCampaignDetails } from 'scenes/Campaigns/ParentCampaigns/data';

import { CostModelForm } from 'scenes/Campaigns/components/CostModel';

export const CostModelFormCreate = ({ campaignId, ...props }) => {
  const { data: campaignData } = useLoadParentCampaignDetails({
    id: campaignId,
  });
  return (
    <CostModelForm
      {...props}
      title={'Add Cost Model period'}
      subTitle={campaignData?.name}
    />
  );
};

export const CostModelFormEdit = ({
  onSubmit,
  campaignId,
  id,
  onClose,
  initialValues,
  ...props
}) => {
  const { data: campaignData } = useLoadParentCampaignDetails({
    id: campaignId,
  });
  const singleCostPeriod = initialValues?.type?.isSingleCostPeriod || false;
  return (
    <CostModelForm
      {...props}
      onClose={onClose}
      title={'Edit Cost Model period'}
      subTitle={campaignData?.name}
      initialValues={initialValues}
      onSubmit={onSubmit}
      canAddPeriod={!singleCostPeriod}
      canRemovePeriod={true}
      entityId={id}
      isEdit
    />
  );
};
